let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8c61R")).then(() => parcelRequire('iABw2'));